var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"option-container d-flex flex-column justify-center align-center",attrs:{"cols":"12","sm":"10","md":"7","lg":"5","xl":"5"}},_vm._l((_vm.testOptions),function(option){return _c('TestOptionButton',{key:option.id,attrs:{"item":option}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }